import { axiosApiInstance } from './axiosInstances';
import { folderI } from '@/interfaces/folderI';
import store from '../store/store';

export const getWorkspaceList = (): Promise<folderI[]> => {
  return axiosApiInstance
    .get(`/api/v1/workspaces?userId=${store.getters.userId}`)
    .then((response) => {
      return response.data.result.workspace_list.map((workspace: any) => {
        return {
          name: workspace.name,
          description: workspace.description,
          id: workspace.workspace_id,
        };
      });
    });
};

export const getDatasetList = (workspaceId: string): Promise<folderI[]> => {
  return axiosApiInstance
    .get(`/api/v1/workspaces/${workspaceId}/datasets`)
    .then((response) => {
      return response.data.result.dataset_list.map((dataset: any) => {
        return {
          name: dataset.name,
          description: dataset.description,
          id: dataset.dataset_id,
          analysisStatus: dataset.analysis_status,
        };
      });
    });
};

export const getLabelsetList = (datasetId: string): Promise<folderI[]> => {
  return axiosApiInstance
    .get(`/api/v1/datasets/${datasetId}/labelsets`)
    .then((response) => {
      return response.data.result.labelset_list.map((labelset: any) => {
        return {
          name: labelset.name,
          description: labelset.description,
          id: labelset.labelset_id,
          analysisStatus: labelset.analysis_status,
        } as folderI;
      });
    });
};
